import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {FormattedMessage, injectIntl} from "react-intl";

import {
  DISCOUNT_SECTION_TYPES,
  discountInterFace,
  discountSectionsInterface,
  DISCOUNT_FINANCE_CELLS
} from "./discounstInterface";
import {
  setAllFinanceOptionsPopupVisible,
  setDiscountSections, setFinanceCellsVisible,
  setFinancePercentage
} from "../../actions/priceWorksheetActions";
import DiscountDropdown from "../ui/dropdowns/discountDropdown";
import DiscountCommon from "./discountCommon";
import {
  calculateCellValue, getDiscountCurrentValue,
  getDiscountSectionsForCurrentWizard,
  shouldUseMultipleWorkSheets
} from "./discountFunctions";
import {getQuotePriceWithTaxes, getTotalPrice} from "../../misc/helpers";


class DiscountFinance extends DiscountCommon {

  componentDidMount() {
    const {financePercentage, discountSections} = this.props;
    const financeSection = discountSections.find(sec => sec.type === DISCOUNT_SECTION_TYPES.finance);
    const parsedOptions = this.getParsedOptions();

    if (!financePercentage && financeSection) {
      const withPercentage = financeSection.discounts.find(dis => parsedOptions.includes(dis.uuId) && dis.financePercentage)
        || financeSection.discounts.find(dis => dis.financePercentage); // at least something
      if (withPercentage) {
        this.props.setFinancePercentage(withPercentage.financePercentage);
      }
    }
  }

  getParsedOptions = () => {
    const {discount, activeQuoteIndex, hasMultipleWorkSheets} = this.props;
    const realFinanceOptions = getDiscountCurrentValue(discount, "financeOptions", activeQuoteIndex,
      hasMultipleWorkSheets);
    return typeof realFinanceOptions === "string" ? JSON.parse(realFinanceOptions) : [];
  }

  percentageChangeClick = (dropdownItem) => {
    this.props.setFinancePercentage(dropdownItem.discount.financePercentage);
  }

  monthChangeClick = (selectedItem, propertyIndex) => {
    let parsedOptions = this.getParsedOptions();
    parsedOptions[propertyIndex] = selectedItem.discount.uuId;
    this.setDiscountProperty("financeOptions", JSON.stringify(parsedOptions));
  }

  getDropdownOptions = (financeSection, property, textAfterProperty = "") => {
    let dropdownPercentageItems = [];
    financeSection.discounts.forEach((dis) => {
      if (!dropdownPercentageItems.some(dropdownItem => dropdownItem.discount[property] === dis[property])) {
        dropdownPercentageItems.push({
          value: dis.uuId || (dis.id + "-" + dis.order),
          text: dis[property] + textAfterProperty,
          discount: dis,
        })
      }
    });
    return dropdownPercentageItems
  }

  setCellVisible = () => {
    if (!this.props.financeCellsVisible) {
      this.props.setFinanceCellsVisible(true);
    }
  }

  render() {
    const {discountSections, financePercentage, setAllFinanceOptionsPopupVisible, intl, financeCellsVisible,
      activeQuoteIndex, hasMultipleWorkSheets} = this.props;
    const financeSection = discountSections.find(sec => sec.type === DISCOUNT_SECTION_TYPES.finance);
    if (!financeSection) {
      return null;
    }

    let parsedOptions = this.getParsedOptions();

    // console.log("parsedOptions", parsedOptions)
    // console.log("financeSection", financeSection);

    const dropdownPercentageItems = this.getDropdownOptions(financeSection, "financePercentage", "%");
    const dropdownMonthItems = this.getDropdownOptions(financeSection, "financeMonths", " " + intl.formatMessage({id: "shoppingCart.discounts.months"}));

    const totalPrice = hasMultipleWorkSheets ? getTotalPrice(activeQuoteIndex) : getTotalPrice();
    const grandTotal = getQuotePriceWithTaxes(totalPrice, discountSections);

    return (
      <li className={"discount discount--finance"}>
        <div className="text-left margin-b-12">
          <span className="bold block">
            <FormattedMessage id="shoppingCart.discounts.financeTitle"/>
          </span>
          <span className="block margin-b-8 text-left">
            <FormattedMessage id="shoppingCart.discounts.financeSubTitle"/>
          </span>
          <div className="flex flex--center flex--between">
            <div className="inline-block">
              <DiscountDropdown dropdownItems={dropdownPercentageItems}
                                dropdownTitle={intl.formatMessage({id: "shoppingCart.discounts.percentage"})}
                                selectItemClick={this.percentageChangeClick}>
                <div className="dr-select">{financePercentage}%</div>
              </DiscountDropdown>
            </div>
            <button className="ui-button flex flex--center discount-info-button"
                    onClick={() => setAllFinanceOptionsPopupVisible(true)}>i</button>
          </div>
        </div>
        <div className="flex">
          {Object.keys(DISCOUNT_FINANCE_CELLS).map((property, propertyIndex) => {
            const selectedDiscount = financeSection.discounts.find(dis => dis.uuId === parsedOptions[propertyIndex]);
            return (
              <div className={"discount-finance__cell flex flex--center flex--1 relative"
                + (financeCellsVisible ? " discount-finance__cell--no-hover" : "")}
                   onClick={this.setCellVisible}
                   key={property}>
                <DiscountDropdown dropdownItems={dropdownMonthItems}
                                  dropdownTitle={intl.formatMessage({id: "shoppingCart.discounts.term"})}
                                  selectItemClick={(selectedItem) => this.monthChangeClick(selectedItem, propertyIndex)}>
                  <div className="discount-finance__cell-months">
                    {selectedDiscount
                      ? selectedDiscount.financeMonths + " " + intl.formatMessage({id: "shoppingCart.discounts.months"})
                      : intl.formatMessage({id: "shoppingCart.discounts.selectTerm"})}
                  </div>
                </DiscountDropdown>
                <div className="discount-finance__cell-amount">
                  {financeCellsVisible ? calculateCellValue(
                    this.props,
                    selectedDiscount ? selectedDiscount.financeMonths : 0,
                    grandTotal,
                  ) : null}
                </div>
              </div>
            )
          })}
        </div>
      </li>
    )
  }
}

DiscountFinance.propTypes = {
  discount: PropTypes.shape(discountInterFace),
  discountSection: PropTypes.shape(discountSectionsInterface),
};

const mapStateToProps = (store) => {
  const {discountSections, customAddedDiscounts, financePercentage, financeCellsVisible, workSheetsCount}
    = store.priceWorksheetState;
  const {allWizardsValues} = store.wizardState;
  const {activeQuoteIndex, quotes} = store.quotesState;
  const {jobIsSaving} = store.serverState;

  return {
    discountSections: getDiscountSectionsForCurrentWizard(discountSections,
      allWizardsValues, activeQuoteIndex),
    customAddedDiscounts,
    financePercentage,
    financeCellsVisible,
    // Total requirements
    cartItems: store.cartState.cartItems,
    instList: store.instState.instList,
    fabricatorTaxes: store.fabricatorState.fabricatorTaxes,
    // Total requirements end
    fabricatorData: store.fabricatorState,
    fabricatorSettings: store.fabricatorState.settings,
    allWizardsValues,
    activeQuoteIndex,
    workSheetsCount,
    quotes,
    hasMultipleWorkSheets: shouldUseMultipleWorkSheets(workSheetsCount),
    jobIsSaving,
  };
};

const mapDispatchToProps = {
  setDiscountSections,
  setFinancePercentage,
  setAllFinanceOptionsPopupVisible,
  setFinanceCellsVisible,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(DiscountFinance)
)
